var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from "prop-types";

import { Widget, WidgetHeader, WidgetTitle, WidgetDescription, WidgetBody, WidgetFooter, WidgetLoading } from "../";
import { Chart } from "../";

import "./DataWidget.scss";

var DataWidget = (_temp2 = _class = function (_Component) {
    _inherits(DataWidget, _Component);

    function DataWidget() {
        var _temp, _this, _ret;

        _classCallCheck(this, DataWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getSize = function () {
            var widgetSize = _this.props.widgetSize;


            if (!widgetSize) {
                return {};
            }

            var grid = widgetSize.split(":");

            return {
                cols: parseInt(grid[0]),
                rows: parseInt(grid[1])
            };
        }, _this.getChart = function () {
            var _this$props = _this.props,
                chart = _this$props.chart,
                theme = _this$props.theme,
                widgetSize = _this$props.widgetSize;

            var _this$getSize = _this.getSize(),
                cols = _this$getSize.cols,
                rows = _this$getSize.rows;

            var padding = void 0,
                margin = void 0,
                offset = void 0;

            margin = {
                top: 60,
                right: 0,
                bottom: 0,
                left: 0
            };

            if (cols && cols >= 2) {
                margin.top = 75;
            } else {}

            offset = {
                top: margin.top * -1,
                right: 0,
                bottom: 0,
                left: 0
            };

            return _extends({}, chart, {
                margin: margin,
                offset: offset,
                theme: theme
            });
        }, _this.renderChart = function () {
            var chart = _this.getChart();

            if (chart) {
                return React.createElement(Chart, chart);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    DataWidget.prototype.render = function render() {
        var _props = this.props,
            loading = _props.loading,
            chart = _props.chart,
            title = _props.title,
            titleUrl = _props.titleUrl,
            description = _props.description;


        if (loading) {

            return React.createElement(
                Widget,
                this.props,
                React.createElement(WidgetLoading, { title: title, description: description })
            );
        }

        return React.createElement(
            Widget,
            this.props,
            React.createElement(
                WidgetHeader,
                null,
                React.createElement(WidgetTitle, { title: title, url: titleUrl }),
                React.createElement(WidgetDescription, { description: description })
            ),
            React.createElement(
                WidgetBody,
                null,
                this.renderChart()
            )
        );
    };

    return DataWidget;
}(Component), _class.defaultProps = {
    expanded: true,
    widgetType: "data",
    widgetSize: "1:1",
    chart: {
        type: undefined,
        metric: undefined,
        range: undefined,
        compare: undefined,
        stacked: undefined
    }
}, _temp2);


export default DataWidget;